import styled from 'styled-components';
import media from '../media';
import { AppTheme } from '../../styles/theme';

export type ButtonVariant = 'default' | 'secondary' | 'tertiary';
type ButtonProps = { variant?: ButtonVariant; fullWidth?: boolean } & { theme: AppTheme };

const getStartBgColor = (props: ButtonProps) => {
  switch (props.variant) {
    case 'secondary':
      return 'transparent';
    case 'tertiary':
      return 'white';
    default:
      return 'transparent';
  }
};

const getHoverBgColor = () => {
  return 'transparent';
};

const getStartFontColor = (props: ButtonProps) => {
  switch (props.variant) {
    case 'secondary':
      return 'white';
    case 'tertiary':
      return props.theme.colors.blue;
    default:
      return props.theme.colors.darkText;
  }
};

const getHoverFontColor = () => {
  return 'white';
};

const getStartBorderColor = () => () => {
  return 'transparent';
};

const getHoverBorderColor = (first?: boolean) => (props: ButtonProps) => {
  switch (props.variant) {
    case 'secondary':
      return '#57ddff';
    case 'tertiary':
      return '#57ddff';
    default:
      return first ? '#57ddff' : '#3888FC';
  }
};

/**
 * Button
 * @deprecated This button is using the old styles and must be refactored
 */
export const Button = styled.button<ButtonProps>`
  width: ${(props) => (props.fullWidth ? '100%' : 'fit-content')};
  position: relative;
  padding: 10px 20px;
  font-size: 1em;
  ${media('medium')} {
    padding: 14px 40px;
    font-size: 1.2em;
  }
  font-weight: 400;
  color: ${getStartFontColor};
  border-radius: 6px;
  cursor: pointer;
  border: 1px solid ${getStartFontColor};
  background: ${getStartBgColor};
  z-index: 1;
  :hover {
    border: 1px solid transparent;
    color: ${getHoverFontColor};
    background: ${getHoverBgColor};
    ::after {
      background-image: linear-gradient(
        to left,
        ${getHoverBorderColor(true)} 0%,
        ${getHoverBorderColor()} 100%
      );
    }
  }
  :focus-visible {
    outline: 2px solid ${getStartBgColor};
    outline-offset: 2px;
  }
  ::after {
    content: ' ';
    position: absolute;
    border-radius: 7px;
    top: -1px;
    right: -1px;
    bottom: -1px;
    left: -1px;
    background-image: linear-gradient(
      to left,
      ${getStartBorderColor()} 0%,
      ${getStartBorderColor()} 100%
    );
    z-index: -1;
  }
`;
